
export const GOOGLE_SITE_KEY = '6LfUtg4dAAAAAJnvuoQ0imwXtLSLtIsIrFOXmQ7n';

export const FORMSPREE_URL = 'https://formspree.io/f/xpzkgdga';
